// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"efa08962","453":"35f66e56","455":"90b3f2e2","977":"ee5948b2"}[chunkId] + ".chunk.js";
};